import { Icon } from "@chakra-ui/react"

export const SlidedeckIcon = (props: any) => (
  <Icon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 93.66 104.93">
    <g id="Group_1670" transform="translate(0 0)">
    <path id="Path_719" d="M79.61,29.84L58.97,9.21c-0.48-0.48-1.14-0.76-1.82-0.76H21.05c-4.27,0-7.73,3.47-7.74,7.74v72.56
      c0,4.27,3.47,7.73,7.74,7.74h51.58c4.27-0.01,7.72-3.47,7.73-7.74V31.66C80.35,30.98,80.09,30.32,79.61,29.84z M59.73,17.26
      l11.83,11.83h-9.25c-1.42,0-2.58-1.16-2.58-2.58V17.26z M72.62,91.32H21.05c-1.42,0-2.58-1.16-2.58-2.58V16.19
      c0-1.42,1.16-2.58,2.58-2.58h33.53V26.5c0,4.27,3.47,7.73,7.74,7.74H75.2v54.5C75.2,90.17,74.05,91.32,72.62,91.32z"/>
    <path id="Path_720" d="M62.31,47.48H31.36c-1.42,0-2.58,1.15-2.58,2.58l0,0v25.79c0,1.42,1.15,2.58,2.58,2.58l0,0h30.95
      c1.42,0,2.58-1.15,2.58-2.58l0,0V50.06C64.89,48.64,63.73,47.48,62.31,47.48L62.31,47.48z M59.73,73.27H33.94V52.64h25.79V73.27z"
      />
  </g>
  </Icon>
);
